<template>
  <div>
    <Title title="Login"></Title>

    <Header />
    <v-content>
      <v-container class="form-body mt-12">
        <v-row>
          <v-col lg="12">
            <v-alert text type="error" v-if="alertMessage">
              <strong>{{ alertMessage }}</strong>
            </v-alert>
            <h2>Log In</h2>

            <v-form ref="loginForm" class="mt-5">
              <v-text-field
                v-model="email"
                label="E-mail"
                required
                ref="firstInput"
                :rules="emptyRule"
                >></v-text-field
              >

              <v-text-field
                type="password"
                v-model="password"
                label="Password"
                required
                :rules="emptyRule"
              ></v-text-field>

              <v-row>
                <v-col lg="12">
                  <v-dialog v-model="dialog" max-width="450px" ref="dialog">
                    <template v-slot:activator="{ on, attrs }">
                      <p dark v-bind="attrs" v-on="on">
                        <a style="text-decoration: underline"
                          >Forgot password</a
                        >
                      </p>
                    </template>
                    <v-card class="py-5">
                      <v-card-title>
                        <h6 class="headline">Reset password</h6>
                      </v-card-title>
                      <v-card-text class="pb-0">
                        <v-container>
                          <v-row>
                            <v-col cols="12" class="px-0">
                              <v-text-field
                                label="Your email"
                                required
                                v-model="resetEmail"
                                :rules="emptyRule"
                              ></v-text-field>
                              <p>{{ feedbackMessage }}</p>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="onConfirmEmail()"
                          >Email me a recovery link</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>

              <v-btn
                block
                tile
                style="color: white"
                class="primary-color"
                ref="submitBtn"
                id="submit-btn"
                @click="onLogin()"
                >Log In</v-btn
              >
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import Header from "../components/Header";
import Title from "../components/Title";

export default {
  mounted: function () {
    this.$refs.firstInput.focus();
  },
  data: function () {
    return {
      feedbackMessage: "",
      dialog: false,
      email: null,
      password: null,
      resetEmail: null,
      alertMessage: null,
      emptyRule: [(v) => !!v || "This field is required"],
    };
  },
  components: {
    Header,
    Title,
  },
  methods: {
    onLogin: function () {
      if (!this.$refs.loginForm.validate()) {
        return;
      }

      this.alertMessage = null;
      this.$store.commit("switchProgressStatus", true);

      const data = { email: this.email, password: this.password };

      fetch(`${process.env.VUE_APP_ROOT_API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$store.commit("switchProgressStatus", false);

          if (data.status == "success") {
            this.$store.commit("updateJwt", data.token);
            this.$store.commit("updateEmail", data.email);
            this.$store.commit("updateRole", data.role);
            this.$store.commit("updateFirstLogin", data.firstLogin);
            this.$store.commit("updateUserId", data.userId);
            this.$router.push({ name: "Dashboard" });
          } else if (data.status == "fail") {
            this.alertMessage = data.message;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onConfirmEmail: function () {
      this.feedbackMessage = 'Please hold on. Sending email...';

      fetch(`${process.env.VUE_APP_ROOT_API}/auth/password/email`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: this.resetEmail }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.feedbackMessage = data.message;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
* {
  background-color: #fdfdfd;
}

.form-body {
  width: 40%;
}

#submit-btn {
  height: 45px;
  font-size: 17px;
  font-weight: 500;
}
</style>